import { render, staticRenderFns } from "./MovementStock.vue?vue&type=template&id=2c58a10d&scoped=true"
import script from "./MovementStock.vue?vue&type=script&lang=js"
export * from "./MovementStock.vue?vue&type=script&lang=js"
import style0 from "./MovementStock.vue?vue&type=style&index=0&id=2c58a10d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c58a10d",
  null
  
)

export default component.exports